import { useState } from "react";
import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const DateField = ({ value, onChange, testid, placeholder = "gg/mm/aaaa", className = "", disabled, max, clearable }) => {
  const [open, setOpen] = useState(false);
  const d = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} disabled={disabled}
          className={`flex h-9 w-full items-center gap-2 rounded-md border border-input bg-transparent px-3 text-left text-sm shadow-sm transition-colors hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}>
          <CalendarDays className="h-4 w-4 shrink-0 text-slate-500" />
          <span className={`flex-1 truncate ${d ? "text-slate-900" : "text-slate-400"}`}>{d ? format(d, "dd/MM/yyyy") : placeholder}</span>
          {d && clearable && !disabled && <span role="button" aria-label="Cancella data" data-testid={`${testid}-clear`} className="-mr-2 flex h-8 w-8 items-center justify-center rounded text-slate-400 hover:bg-slate-100 hover:text-slate-700" onClick={(e) => { e.stopPropagation(); e.preventDefault(); onChange(""); }}><X className="h-4 w-4" /></span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={it} weekStartsOn={1} selected={d} defaultMonth={d} disabled={max ? { after: parseISO(max) } : undefined}
          onSelect={(x) => { if (x) onChange(format(x, "yyyy-MM-dd")); setOpen(false); }} />
      </PopoverContent>
    </Popover>
  );
};
